export const LoginImagesTypes = {
  IListLoginImageService: Symbol("IListLoginImageService"),
  IRemoveLoginImageService: Symbol("IRemoveLoginImageService"),
  IUploadLoginImageService: Symbol("IUploadLoginImageService"),
};
